import { render } from "./_Certificado.vue?vue&type=template&id=1b21b3fe&scoped=true"
import script from "./_Certificado.vue?vue&type=script&lang=ts"
export * from "./_Certificado.vue?vue&type=script&lang=ts"

import "./_Certificado.vue?vue&type=style&index=0&id=1b21b3fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b21b3fe"

export default script